export const validate = (value: string): string | undefined => (value ? undefined : 'error');
export const validateCounter = (value: number): string | undefined => (value !== 0 ? undefined : 'error');
